module.exports = __webpack_public_path__ + "img/produktionsmechanikerin_s_h_-3819.b389c7a8.jpg";